import { render, staticRenderFns } from "./ProductLabelPreviewListItem.vue?vue&type=template&id=5040add0&scoped=true&"
import script from "./ProductLabelPreviewListItem.vue?vue&type=script&lang=js&"
export * from "./ProductLabelPreviewListItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductLabelPreviewListItem.vue?vue&type=style&index=0&id=5040add0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5040add0",
  null
  
)

export default component.exports